"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _FormInputText = _interopRequireDefault(require("./FormInputText"));
var _FormInputDisplay = _interopRequireDefault(require("./FormInputDisplay"));
var _FormInputTextArea = _interopRequireDefault(require("./FormInputTextArea"));
var _FormInputRadio = _interopRequireDefault(require("./FormInputRadio"));
var _FormInputFile = _interopRequireDefault(require("./FormInputFile"));
var _FormInputImage = _interopRequireDefault(require("./FormInputImage"));
var _FormInputSelect = _interopRequireDefault(require("./FormInputSelect"));
var _FormInputCheckbox = _interopRequireDefault(require("./FormInputCheckbox"));
var _FormInputEditor = _interopRequireDefault(require("./FormInputEditor"));
var _FormInputToggle = _interopRequireDefault(require("./FormInputToggle"));
var _FormInputPassword = _interopRequireDefault(require("./FormInputPassword"));
var _FormInputHidden = _interopRequireDefault(require("./FormInputHidden"));
var _FormInputFancyCheckbox = _interopRequireDefault(require("./FormInputFancyCheckbox"));
var _FormLinkedTable = _interopRequireDefault(require("./FormLinkedTable"));
var _FormInputDate = _interopRequireDefault(require("./FormInputDate"));
var _FormInputTime = _interopRequireDefault(require("./FormInputTime"));
var _FormInputSimpleEditor = _interopRequireDefault(require("./FormInputSimpleEditor"));
var _FormInputState = _interopRequireDefault(require("./FormInputState"));
var _FormInputCountry = _interopRequireDefault(require("./FormInputCountry"));
var _FormInputDataList = _interopRequireDefault(require("./FormInputDataList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const FormInput = props => {
  let {
    label,
    type,
    inputSize,
    floatingLabel
  } = props;
  let inputSizeClass = "form-control";
  if (inputSize === "sm") inputSizeClass += " form-control-sm";
  if (inputSize === "lg") inputSizeClass += " form-control-lg";
  let floatingLabelClass = "form-group";
  if (floatingLabel) floatingLabelClass = " form-floating";
  let divColSize = 12;
  if (props.colSize === 0) divColSize = 0;
  if (props.colSize === 1) divColSize = 12;
  if (props.colSize === 2) divColSize = 6;
  if (props.colSize === 3) divColSize = 4;
  if (props.colSize === 4) divColSize = 8;
  props = _objectSpread(_objectSpread({}, props), {}, {
    inputSizeClass,
    floatingLabelClass,
    divColSize
  });
  switch (type) {
    case "checkbox":
      return /*#__PURE__*/_react.default.createElement(_FormInputCheckbox.default, props);
    case "date":
      return /*#__PURE__*/_react.default.createElement(_FormInputDate.default, props);
    case "display":
      return /*#__PURE__*/_react.default.createElement(_FormInputDisplay.default, props);
    case "editor":
    case "content":
      return /*#__PURE__*/_react.default.createElement(_FormInputEditor.default, props);
    case "email":
      return /*#__PURE__*/_react.default.createElement(_FormInputText.default, props);
    case "fancyCheckbox":
      return /*#__PURE__*/_react.default.createElement(_FormInputFancyCheckbox.default, props);
    case "file":
      return /*#__PURE__*/_react.default.createElement(_FormInputFile.default, props);
    case "drag":
      return /*#__PURE__*/_react.default.createElement(FormInputFileDrag, props);
    case "hidden":
      return /*#__PURE__*/_react.default.createElement(_FormInputHidden.default, props);
    case "upload":
    case "image":
      return /*#__PURE__*/_react.default.createElement(_FormInputImage.default, props);
    case "inline-upload":
      return /*#__PURE__*/_react.default.createElement(FormInputInlineUpload, props);
    case "number":
      return /*#__PURE__*/_react.default.createElement(_FormInputText.default, props);
    case "password":
      return /*#__PURE__*/_react.default.createElement(_FormInputPassword.default, props);
    case "radio":
      return /*#__PURE__*/_react.default.createElement(_FormInputRadio.default, props);
    case "select":
    case "dropdown":
      return /*#__PURE__*/_react.default.createElement(_FormInputSelect.default, props);
    case "datalist":
      return /*#__PURE__*/_react.default.createElement(_FormInputDataList.default, props);
    case "simpleEditor":
      return /*#__PURE__*/_react.default.createElement(_FormInputSimpleEditor.default, props);
    case "state":
      return /*#__PURE__*/_react.default.createElement(_FormInputState.default, props);
    case "country":
      return /*#__PURE__*/_react.default.createElement(_FormInputCountry.default, props);
    case "text":
      return /*#__PURE__*/_react.default.createElement(_FormInputText.default, props);
    case "textarea":
      return /*#__PURE__*/_react.default.createElement(_FormInputTextArea.default, props);
    case "time":
      return /*#__PURE__*/_react.default.createElement(_FormInputTime.default, props);
    case "toggle":
      return /*#__PURE__*/_react.default.createElement(_FormInputToggle.default, props);
    case "title":
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-12 p-2 bg-secondary text-white mb-2"
      }, /*#__PURE__*/_react.default.createElement("b", null, label));
    case "linkedTable":
      return /*#__PURE__*/_react.default.createElement(_FormLinkedTable.default, props);
    default:
      return /*#__PURE__*/_react.default.createElement(_FormInputText.default, props);
  }
};
FormInput.propTypes = {
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  type: _propTypes.default.string,
  inputSize: _propTypes.default.string,
  floatingLabel: _propTypes.default.bool,
  colSize: _propTypes.default.number,
  hideBorder: _propTypes.default.bool,
  hideLabel: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  hideMeter: _propTypes.default.bool,
  refProp: _propTypes.default.object,
  tinyMCEApiKey: _propTypes.default.string,
  uploadUrl: _propTypes.default.string
};
var _default = FormInput;
exports.default = _default;